export default class addToTag {
    constructor() {
        return {
            template: require('../../../../views/subscriber/modal/add-to-tag.html'),
            replace: true,
            restrict: 'E',
            scope: {},
            controller: AddToTagCtrl,
            controllerAs: 'layover'
        }
    }
};

class AddToTagCtrl {
    constructor($scope, $filter, Tag) {
        this._scope = $scope;
        this.tagRepo = Tag;

        this._scope.$on('subscribers:addToTag:show', (event, count) => {
            this.show = true;
            this.tags = [];

            this.description = $filter('translate')('SUBSCRIBER_MODAL:ADD_TO_TAG:DESCRIPTION').replace(':subscribers_count', count);
        });

        $(document).keyup((e) => {
            if (e.keyCode == 27) {
                this.show = false;
                this._scope.$apply(); // Close modal on escape.
            }
        });
    }

    close() {
        this.show = false;
    };

    add() {
        if (this.tags.length) {
            this._scope.$emit('subscribers:addToTag:add', this.tags);
        }
        this.close();
    };
}